if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        // Mobile: Dawn only dismisses media-modal on mouse pointerup.
        // Also close on touch/pen tap outside the active media.
        this.addEventListener('pointerup', (event) => {
          if (event.target.closest('[id^="ModalClose-"]')) return;
          if (event.target.closest('deferred-media, product-model, img, video, model-viewer')) return;
          if (event.target === this || event.target.classList.contains('product-media-modal__dialog')) {
            this.hide();
          }
        });

        const closeBtn = this.querySelector('[id^="ModalClose-"]');
        if (closeBtn) {
          const close = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.hide();
          };
          closeBtn.addEventListener('click', close);
          closeBtn.addEventListener('pointerup', close);
        }
      }

      connectedCallback() {
        super.connectedCallback();

        this._forceClose = () => {
          if (this.hasAttribute('open')) this.hide();
        };

        window.addEventListener('pagehide', this._forceClose);
        window.addEventListener('pageshow', this._forceClose);

        // Close lightbox the moment the mobile nav drawer opens
        this._onNavIntent = (event) => {
          const nav = event.target.closest?.(
            'header-drawer, menu-drawer, .header__icon--menu, summary.header__icon--menu'
          );
          if (!nav) return;
          this._forceClose();
        };
        document.addEventListener('pointerdown', this._onNavIntent, true);
        document.addEventListener('click', this._onNavIntent, true);

        this._watchMenuDrawer();
      }

      _watchMenuDrawer() {
        const drawers = document.querySelectorAll('menu-drawer details, header-drawer details');
        if (!drawers.length) return;

        const sync = (details) => {
          if (details.open) this._forceClose();
        };

        drawers.forEach((details) => {
          details.addEventListener('toggle', () => sync(details));
          // Safari sometimes misses toggle on first paint
          const obs = new MutationObserver(() => sync(details));
          obs.observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
        });
      }

      hide() {
        super.hide();
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        this.querySelectorAll('[data-media-id].active').forEach((el) => el.classList.remove('active'));
      }

      show(opener) {
        // Never open lightbox while the side menu is open
        if (document.querySelector('menu-drawer details[open], header-drawer details[open]')) return;
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        const isCoarse = window.matchMedia('(hover: none), (pointer: coarse)').matches;

        if (container && isCoarse) {
          container.scrollTop = Math.max(0, activeMedia.offsetTop - 16);
        } else {
          activeMedia.scrollIntoView({ block: 'nearest', inline: 'center' });
          if (container && activeMedia.width) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
